<ng-container>
  <div class="margin-2 sparro-grey-800 font-sm">
    <p
      style="
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      ">
      {{ project.content.desc | truncate : 150 }}
    </p>
  </div>
</ng-container>
